import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Invite: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6081 0H2.83048C1.26489 0 0 1.26966 0 2.83048V14.5056C0 16.0665 1.26489 17.3314 2.83048 17.3314H8.93536L11.1787 19.5747C11.7563 20.1523 12.6918 20.1523 13.2694 19.5747L15.5128 17.3314H21.6129C23.1737 17.3314 24.4434 16.0665 24.4434 14.5056V2.83048C24.4386 1.26966 23.1737 0 21.6081 0ZM10.3339 4.4104C11.4126 4.4104 12.2861 5.28389 12.2861 6.36262C12.2861 7.44136 11.4126 8.31485 10.3339 8.31485C9.25516 8.31485 8.38167 7.44136 8.38167 6.36262C8.38167 5.28389 9.25516 4.4104 10.3339 4.4104ZM13.9376 12.0952C13.9376 12.5486 13.5701 12.9162 13.1166 12.9162H7.55114C7.09769 12.9162 6.73016 12.5486 6.73016 12.0952V10.7921C6.73016 9.85658 7.48909 9.09765 8.42463 9.09765H12.2384C13.1739 9.09765 13.9329 9.85658 13.9329 10.7921V12.0952H13.9376ZM17.7084 7.27907C17.7084 7.68956 17.3743 8.02369 16.9638 8.02369H16.4435V8.54873C16.4531 8.95923 16.1285 9.30289 15.718 9.31244C15.3075 9.32199 14.9639 8.99741 14.9543 8.58692C14.9543 8.5726 14.9543 8.56305 14.9543 8.54873V8.02846H14.4293C14.0188 8.02846 13.6847 7.69434 13.6847 7.28385C13.6847 6.87335 14.0188 6.53923 14.4293 6.53923H14.9543V6.01418C14.9448 5.60369 15.2693 5.26002 15.6798 5.25048C16.0903 5.24093 16.434 5.56551 16.4435 5.976V6.01418V6.53923H16.9686C17.3743 6.53446 17.7084 6.86381 17.7084 7.27907Z"
        fill="currentColor"
      />
    </svg>
  )
})

Invite.displayName = 'Invite'
